var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconoCalendarioBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30.55 32.59",
    style: {
      enableBackground: "new 0 0 30.55 32.59"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-calendar",
    d: "M10.18,12.22h4.07v4.07h-4.07V12.22z M16.29,12.22h4.07v4.07h-4.07L16.29,12.22z  M22.4,12.22h4.07v4.07H22.4L22.4,12.22z M4.07,24.44h4.07v4.07H4.07V24.44z M10.18,24.44h4.07v4.07h-4.07V24.44z M16.29,24.44h4.07 v4.07h-4.07L16.29,24.44z M10.18,18.33h4.07v4.07h-4.07V18.33z M16.29,18.33h4.07v4.07h-4.07L16.29,18.33z M22.4,18.33h4.07v4.07 H22.4L22.4,18.33z M4.07,18.33h4.07v4.07H4.07L4.07,18.33z M26.47,0v2.04H22.4V0H8.15v2.04H4.07V0H0v32.59h30.55V0L26.47,0L26.47,0z  M28.51,30.55H2.04V8.15h26.48L28.51,30.55z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoCalendarioBig);
export default __webpack_public_path__ + "static/media/icono-calendario-big.ec860dc455c631afdbd47cb71ee7daf2.svg";
export { ForwardRef as ReactComponent };